module.exports = __webpack_public_path__ + "media/application/images/icons/close-dark-3de4355408715fe4a15f76a6fceb793c.png";